import {
  showErrorToast,
} from '@fff-web/fff-ui-shared/Toast';

const ALLOWED_MIN_HEIGHT = 240;
const ALLOWED_MIN_WIDTH = 240;
const ALLOWED_EXTENSIONS = ['png', 'jpg', 'jpeg', 'heic'];

const onloadAvatar = (imageFile: File, img: HTMLImageElement, onValid: () => void) => (): any => {
  const errorTitle = 'Profile Image Upload Failed';

  const imageFileName = imageFile.name.split('.').pop();
  if (!imageFileName || !ALLOWED_EXTENSIONS.includes(imageFileName.toLowerCase())) {
    showErrorToast(
      errorTitle,
      'Your image did not meet our requirements. Please upload an image that is a PNG, JPG, or HEIC.',
    );
    return false;
  }

  if (img.height < ALLOWED_MIN_HEIGHT || img.width < ALLOWED_MIN_WIDTH) {
    showErrorToast(
      errorTitle,
      'Your image did not meet our requirements. Please upload an image that is at least 240x240.',
    );
    return false;
  }

  onValid();
  return true;
};

export default onloadAvatar;
